import { useQuery } from '@tanstack/react-query';
import { getFeatureFlags } from '../providers/featuresApi';
import { queryKeys } from './queryKeys';
import FeatureManagement from '../models/iFeatureManagement';

export const useFeatureFlags = (bearerToken: string, enabled = true) => {
  return useQuery<FeatureManagement>({
    queryKey: queryKeys.featureFlags(),
    queryFn: () => getFeatureFlags(bearerToken),
    enabled: enabled && !!bearerToken,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });
};
